import Swiper from 'swiper/bundle'

function socialSlider() {
    const sliderEl = document.querySelector('[data-target="social-slider"]')

    if (!sliderEl) return

    const slideNext = document.querySelector('.social-slider-button-next')
    const slidePrev = document.querySelector('.social-slider-button-prev')
    const slides = sliderEl.querySelectorAll('.swiper-slide')

    let swiper

    swiper = new Swiper(sliderEl, {
        effect: 'coverflow',
        slidesPerView: 1.5,
        initialSlide: 2,
        centeredSlides: true,
        autoHeight: true,
        // spaceBetween: -50,
        coverflowEffect: {
            rotate: 0,
            slideShadows: false,
            stretch: 52, // This is the amount of overlap between slides
            depth: 30, // This is the amount of the 3D effect
            modifier: 8, // Controls the intensity of the 3D effect
        },
        navigation: {
            nextEl: slideNext,
            prevEl: slidePrev,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                coverflowEffect: {
                    rotate: 0,
                    slideShadows: false,
                    stretch: 52, // This is the amount of overlap between slides
                    depth: 30, // This is the amount of the 3D effect
                    modifier: 8, // Controls the intensity of the 3D effect
                },
            },
            768: {
                slidesPerView: 1.5,
            },
            900: {
                coverflowEffect: {
                    rotate: 0,
                    slideShadows: false,
                    stretch: 40, // This is the amount of overlap between slides
                    depth: 30, // This is the amount of the 3D effect
                    modifier: 8, // Controls the intensity of the 3D effect
                },
            },
            1280: {
                coverflowEffect: {
                    stretch: 52, // This is the amount of overlap between slides
                },
            },
        },
    })
}

export default socialSlider
